var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26793 5.28995L2.02793 1.04995C1.93497 0.95622 1.82437 0.881826 1.70251 0.831057C1.58065 0.780288 1.44994 0.75415 1.31793 0.75415C1.18592 0.75415 1.05521 0.780288 0.933354 0.831057C0.811495 0.881826 0.700894 0.95622 0.607931 1.04995C0.42168 1.23731 0.317139 1.49076 0.317139 1.75495C0.317139 2.01913 0.42168 2.27259 0.607931 2.45995L4.14793 5.99995L0.607931 9.53995C0.42168 9.72731 0.317139 9.98076 0.317139 10.2449C0.317139 10.5091 0.42168 10.7626 0.607931 10.9499C0.701371 11.0426 0.812187 11.116 0.934025 11.1657C1.05586 11.2155 1.18632 11.2407 1.31793 11.2399C1.44954 11.2407 1.58 11.2155 1.70184 11.1657C1.82368 11.116 1.93449 11.0426 2.02793 10.9499L6.26793 6.70995C6.36166 6.61699 6.43605 6.50638 6.48682 6.38453C6.53759 6.26267 6.56373 6.13196 6.56373 5.99995C6.56373 5.86794 6.53759 5.73723 6.48682 5.61537C6.43605 5.49351 6.36166 5.38291 6.26793 5.28995Z",
    fill: "#BFBFBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.39ad828b02fe03014609a1f844146d9f.svg";
export { ForwardRef as ReactComponent };